'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import FichaPaginaMobileFallback from '../Designs/Mobile/fallback';
import FichaPaginaDesktopFallback from '../Designs/Desktop/fallback';

export default function FichaPaginaFallback() {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <FichaPaginaMobileFallback />
  ) : (
    <FichaPaginaDesktopFallback />
  );
}
